import {observer} from 'mobx-react-lite'
import React, {useLayoutEffect} from 'react'
import { TwDropPlaceholder } from '@components/common/sandbox/list-view/tw-components'
import { useListStore } from '../list-store'

const NestedLevelShift = 24

interface DropPlaceholderProps {
  forceShow?: boolean;
  isStatic?: boolean;
}


export const DropPlaceholder = observer((props: DropPlaceholderProps) => {
  const {
    forceShow,
    isStatic
  } = props;
  const placeholderRef = React.useRef<HTMLDivElement>(null)
  const store = useListStore()
  const {
    visible,
    targetElement,
    isBefore,
    nestedLevel
  } = store.dropPlaceholder

  const finalVisible = visible || forceShow;
  const finalNestedLevel = visible ? nestedLevel : 0;
  const finalTargetElement = visible ? targetElement : null;

  useLayoutEffect(() => {
    if (!placeholderRef.current) {
      return;
    }
    placeholderRef.current.style.marginLeft = `${(finalNestedLevel) * NestedLevelShift}px`;
  }, [finalNestedLevel])

  useLayoutEffect(() => {
    if (!placeholderRef.current) {
      return;
    }
    placeholderRef.current.style.opacity = finalVisible ? '1' : '0';
  }, [finalVisible])

  useLayoutEffect(() => {
    if (!placeholderRef.current) {
      return;
    }
    if (!finalTargetElement || !store.bodyElement) {
      if (forceShow) {
        placeholderRef.current.style.top = '0';
      }
      placeholderRef.current.style.opacity = forceShow ? '1' : '0';
      return;
    }
    placeholderRef.current.style.opacity = '1';
    const targetRect = finalTargetElement.getBoundingClientRect();
    const absoluteTopPosition =  isBefore ? targetRect.top : targetRect.bottom;
    placeholderRef.current.style.top = `${absoluteTopPosition - store.bodyElement.getBoundingClientRect().top}px`;
  }, [finalTargetElement, isBefore, forceShow])

  return <TwDropPlaceholder ref={placeholderRef} $static={isStatic} />
})